// Game-specific server configuration
// This is game-level — another game on Ironbolt defines its own.

import type { PlayerControllerConfig } from "../engine/movement.js";

export interface GameServerConfig {
  mode?: "surf" | "freeplay" | "bhop";
  preset?: string;                              // preset name (shown in server browser)
  controller?: Partial<PlayerControllerConfig>;  // only set for "custom" preset
  gravity?: number;                              // only set for "custom" preset
}

// --- Presets: curated, tested controller + physics bundles ---

export interface Preset {
  name: string;
  description: string;
  controller: {
    maxSpeed: number;
    groundAccel: number;
    airAccel: number;
    airSpeedCap: number;
    friction: number;
    stopSpeed: number;
    jumpVelocity: number;
  };
  gravity: number;
}

export const PRESETS: Record<string, Preset> = {
  classic: {
    name: "Classic",
    description: "Default tuned movement — smooth surf, tight ground control",
    controller: { maxSpeed: 8, groundAccel: 10, airAccel: 100, airSpeedCap: 2, friction: 8, stopSpeed: 2, jumpVelocity: 7 },
    gravity: 20,
  },
};

export const DEFAULT_PRESET = "classic";
export const PRESET_KEYS = Object.keys(PRESETS);
